import React from 'react';
import { CardHeader, Grid, makeStyles } from '@material-ui/core';

import Card from 'components/StyledCard';
import CardContent from 'components/StyledCardContent';

import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { useTranslation } from 'react-i18next';
import { MailingList } from 'features/common/MailingList';
import { departmentActions } from 'actions/departmentActions';
import DepartmentCard from './DepartmentCard';
import IntegrationDepartmentId from './IntegrationDepartmentId';
import PageSpinner from 'components/spinners/PageSpinner';

const useStyles = makeStyles(() => ({
  container: {
    margin: 0,
    maxWidth: '100%',
  },
}));

const DepartmentDetailsTab = () => {
  const { t } = useTranslation(['translations']);

  const classes = useStyles();
  const dispatch = useDispatch();

  const department = useSelector(
    (state: ApplicationState) => state.department?.department,
  );

  const handleDelete = (email: string) => {
    if (department) {
      dispatch(
        departmentActions.removeEmailFromDepartmentMailingList(
          department.departmentId,
          email,
        ),
      );
    }
  };

  const handleAdd = (email: string) => {
    if (department) {
      dispatch(
        departmentActions.addEmailToDepartmentMailingList(
          department.departmentId,
          email,
        ),
      );
    }
  };

  return (
    <PageSpinner isLoading={department === undefined}>
      <Grid container spacing={2}>
        <Grid
          container
          spacing={2}
          direction="row"
          className={classes.container}
        >
          <Grid item xs={6}>
            <DepartmentCard />
          </Grid>
          <Grid item xs={6}>
            <Card>
              <CardHeader
                title={t(
                  'department_page.department_information.labels.mailing_list',
                )}
              />
              <CardContent>
                <MailingList
                  emails={department?.mailingList ?? []}
                  onDelete={handleDelete}
                  onAdd={handleAdd}
                ></MailingList>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6}>
            <Card>
              <CardHeader title={'Integration Department ID'} />
              <CardContent>
                <IntegrationDepartmentId />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </PageSpinner>
  );
};

export { DepartmentDetailsTab };
